<form [formGroup]="form" (ngSubmit)="searchClick()">
  <rask-input class="col-2" aid="maskinnummersok" label="{{texts.Maskinnummer}}"
  formControlName="maskinNr"></rask-input>
  <rask-submit-button color="secondary" aid="maskinnummerSok">{{texts.Sok}}</rask-submit-button>
</form>

<rask-search-result-maskin></rask-search-result-maskin>

@if (searchResult$ | async; as searchResult) {
  <div class="result-container">
    <rask-search-result [data]="searchResult"></rask-search-result>
  </div>
}